// SaveEdits/GetEdits conversion layer. The BE contract is typed (one row per edited cell:
// worksheet / rowNumber / field / oldValue / newValue plus a sequence number), so this module
// translates between the module-level journal (editsStore) and the API models. version gates
// journal semantics the same way the mapping/validation payload versions do.

import { NewSubmissionEdit, SubmissionEditsModel } from "services/DataImportService";
import { CellEditRecord } from "./cellEditsStore";

export const EDITS_PAYLOAD_VERSION = 1;

// Journal → SaveEdits entries. The journal keeps one record per cell (first-original wins),
// so sequence numbers are simply the journal's insertion order.
export function buildEditEntries(edits: Map<string, CellEditRecord>): NewSubmissionEdit[] {
  return [...edits.values()].map((edit, index) => ({
    editSequenceNumber: index + 1,
    worksheet: edit.worksheet,
    rowNumber: edit.rowNumber,
    field: edit.field,
    oldValue: edit.originalValue,
    newValue: edit.newValue,
  }));
}

// GetEdits response → journal records, sequence order preserved. Rows the contract guarantees
// malformed (no worksheet/field) are dropped rather than poisoning the journal.
export function toCellEditRecords(model: SubmissionEditsModel): CellEditRecord[] {
  const entries = [...(model.entries ?? [])].sort((a, b) => (a.editSequenceNumber ?? 0) - (b.editSequenceNumber ?? 0));
  const records: CellEditRecord[] = [];
  for (const entry of entries) {
    if (!entry.worksheet || !entry.field || entry.rowNumber === undefined) continue;
    records.push({
      worksheet: entry.worksheet,
      rowNumber: entry.rowNumber,
      field: entry.field,
      originalValue: entry.oldValue ?? "",
      newValue: entry.newValue ?? "",
      editedAt: (entry.createdDate ?? new Date()).toISOString(),
    });
  }
  return records;
}
